module.exports = __webpack_public_path__ + "static/media/gameoflife.0408b2fb.png";